export default {
    day: '2024-09-28',
    content: {
        card: [
            {
                type: 'bugfix',
                text: '392'
            },
        ],
        horde: [
            {
                unlock: 'hordeItems',
                type: 'bugfix',
                text: '388'
            },
        ],
        farm: [
            {
                type: 'bugfix',
                text: '389'
            },
        ],
        gallery: [
            {
                unlock: 'galleryConversion',
                type: 'balance',
                text: '390',
                balance: 'nerf',
                before: '4x',
                after: '16x'
            },
            {
                unlock: 'galleryConversion',
                type: 'new',
                text: '391'
            },
            {
                unlock: 'galleryConversion',
                type: 'clarity',
                text: '394'
            },
        ],
        horde_1: [
            {
                type: 'bugfix',
                text: '393'
            },
        ],
    }
}
